export const actionTypes = {
  SET_FILL_BONUS_AVAILABLE: "BONUS:SET_FILL_BONUS_AVAILABLE",
  SET_BONUS_DATA: "BONUS:SET_BONUS_DATA",
  SET_FILL_BONUS_PERCENT: "BONUS:SET_SET_FILL_BONUS_PERCENT",
  SET_BONUS_EDIT_MODAL_OPENED: "BONUS:SET_BONUS_EDIT_MODAL_OPENED",
  SET_SHOW_CONGRATS: "BONUS:SET_SHOW_CONGRATS"
}

export type bonusType = {
  id: number;
  count?: number;
  duration?: number;
  type: number;
};